import { useState } from 'react';
import { TextInput, PasswordInput, Button, Paper, Title, Container, Alert, Anchor, Text, Group, Stack } from '@mantine/core';
import { useAuth } from '../components/common/AuthProvider';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSignUp, setIsSignUp] = useState(false);

  const { signIn, signUp } = useAuth();

  const handleAuth = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const action = isSignUp ? signUp : signIn;
    const { error } = await action(email, password);

    if (error) {
      setError(error);
    }
    setLoading(false);
  };

  return (
    <Container size={420} my={40}>
      <Title ta="center" mb={30}>
        {isSignUp ? 'Create an account' : 'Welcome back!'}
      </Title>

      <Paper withBorder shadow="md" p={30} radius="md">
        <form onSubmit={handleAuth}>
          <Stack>
            <TextInput
              label="Email"
              placeholder="you@example.com"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <PasswordInput
              label="Password"
              placeholder="Your password"
              required
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
            />

            {error && (
              <Alert color="red" title="Error">
                {error}
              </Alert>
            )}

            <Button fullWidth type="submit" loading={loading}>
              {isSignUp ? 'Sign up' : 'Sign in'}
            </Button>
          </Stack>
        </form>

        <Group justify="space-between" mt="xl">
          <Text c="dimmed" size="sm">
            {isSignUp ? 'Already have an account?' : "Don't have an account yet?"}
          </Text>
          <Anchor component="button" type="button" size="sm" onClick={() => setIsSignUp(!isSignUp)}>
            {isSignUp ? 'Sign in' : 'Create account'}
          </Anchor>
        </Group>
      </Paper>
    </Container>
  );
}
